exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Lr7I{display:-webkit-box;display:-ms-flexbox;display:flex;background-color:#bbe2b687;padding:12px;margin-top:-5px;margin-bottom:15px}._1UKg2{margin-top:15px}._2PL4m{height:27px;width:auto;padding-left:20px;margin:auto 0;opacity:.8}._3irrr{font-size:15px;font-weight:600;color:#525252;padding-left:13px;padding-top:3px}", ""]);

// exports
exports.locals = {
	"root": "_2Lr7I",
	"mobileRoot": "_1UKg2",
	"icon": "_2PL4m",
	"title": "_3irrr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/SuccessBlock/SuccessBlock.css
// module id = 3271
// module chunks = 32